import React from 'react';
import Icon from 'components/AppIcon';

const FilterControls = ({ filters, onFilterChange, currentLanguage }) => {
  const handleFilterChange = (key, value) => {
    onFilterChange({
      ...filters,
      [key]: value
    });
  };

  const clearAllFilters = () => {
    onFilterChange({
      serviceType: 'all',
      poolSize: 'all',
      location: 'all',
      sortBy: 'recent'
    });
  };

  const serviceTypeOptions = [
    { value: 'all', label: { es: 'Todos los Servicios', en: 'All Services' } },
    { value: 'deep-cleaning', label: { es: 'Limpieza Profunda', en: 'Deep Cleaning' } },
    { value: 'maintenance', label: { es: 'Mantenimiento', en: 'Maintenance' } },
    { value: 'restoration', label: { es: 'Restauración', en: 'Restoration' } },
    { value: 'commercial', label: { es: 'Comercial', en: 'Commercial' } },
    { value: 'premium', label: { es: 'Premium', en: 'Premium' } },
    { value: 'community', label: { es: 'Comunitario', en: 'Community' } }
  ];

  const poolSizeOptions = [
    { value: 'all', label: { es: 'Todos los Tamaños', en: 'All Sizes' } },
    { value: 'small', label: { es: 'Pequeña', en: 'Small' } },
    { value: 'medium', label: { es: 'Mediana', en: 'Medium' } },
    { value: 'large', label: { es: 'Grande', en: 'Large' } },
    { value: 'extra-large', label: { es: 'Extra Grande', en: 'Extra Large' } }
  ];

  const locationOptions = [
    { value: 'all', label: { es: 'Todas las Ubicaciones', en: 'All Locations' } },
    { value: 'San José', label: { es: 'San José', en: 'San José' } },
    { value: 'Escazú', label: { es: 'Escazú', en: 'Escazú' } },
    { value: 'Santa Ana', label: { es: 'Santa Ana', en: 'Santa Ana' } },
    { value: 'Heredia', label: { es: 'Heredia', en: 'Heredia' } },
    { value: 'Cartago', label: { es: 'Cartago', en: 'Cartago' } },
    { value: 'Alajuela', label: { es: 'Alajuela', en: 'Alajuela' } }
  ];

  const sortOptions = [
    { value: 'recent', label: { es: 'Más Recientes', en: 'Most Recent' } },
    { value: 'oldest', label: { es: 'Más Antiguos', en: 'Oldest' } },
    { value: 'rating', label: { es: 'Mejor Calificación', en: 'Highest Rating' } }
  ];

  const hasActiveFilters = filters.serviceType !== 'all' || filters.poolSize !== 'all' || filters.location !== 'all' || filters.sortBy !== 'recent';

  return (
    <div className="space-y-4">
      {/* Filter Header */}
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-heading font-semibold text-text-primary">
          {currentLanguage === 'es' ? 'Filtrar Proyectos' : 'Filter Projects'}
        </h3>
        {hasActiveFilters && (
          <button
            onClick={clearAllFilters}
            className="flex items-center space-x-2 text-sm text-primary hover:text-primary/80 nav-transition"
          >
            <Icon name="X" size={16} />
            <span>{currentLanguage === 'es' ? 'Limpiar Filtros' : 'Clear Filters'}</span>
          </button>
        )}
      </div>

      {/* Filter Controls */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Service Type Filter */}
        <div>
          <label className="block text-sm font-medium text-text-secondary mb-2">
            {currentLanguage === 'es' ? 'Tipo de Servicio' : 'Service Type'}
          </label>
          <select
            value={filters.serviceType}
            onChange={(e) => handleFilterChange('serviceType', e.target.value)}
            className="w-full px-3 py-2 border border-border rounded-lg bg-surface text-text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          >
            {serviceTypeOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label[currentLanguage]}
              </option>
            ))}
          </select>
        </div>

        {/* Pool Size Filter */}
        <div>
          <label className="block text-sm font-medium text-text-secondary mb-2">
            {currentLanguage === 'es' ? 'Tamaño de Piscina' : 'Pool Size'}
          </label>
          <select
            value={filters.poolSize}
            onChange={(e) => handleFilterChange('poolSize', e.target.value)}
            className="w-full px-3 py-2 border border-border rounded-lg bg-surface text-text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          >
            {poolSizeOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label[currentLanguage]}
              </option>
            ))}
          </select>
        </div>

        {/* Location Filter */}
        <div>
          <label className="block text-sm font-medium text-text-secondary mb-2">
            {currentLanguage === 'es' ? 'Ubicación' : 'Location'}
          </label>
          <select
            value={filters.location}
            onChange={(e) => handleFilterChange('location', e.target.value)}
            className="w-full px-3 py-2 border border-border rounded-lg bg-surface text-text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          >
            {locationOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label[currentLanguage]}
              </option>
            ))}
          </select>
        </div>

        {/* Sort Filter */}
        <div>
          <label className="block text-sm font-medium text-text-secondary mb-2">
            {currentLanguage === 'es' ? 'Ordenar Por' : 'Sort By'}
          </label>
          <select
            value={filters.sortBy}
            onChange={(e) => handleFilterChange('sortBy', e.target.value)}
            className="w-full px-3 py-2 border border-border rounded-lg bg-surface text-text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
          >
            {sortOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label[currentLanguage]}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Active Filters Display */}
      {hasActiveFilters && (
        <div className="flex flex-wrap gap-2">
          {filters.serviceType !== 'all' && (
            <span className="inline-flex items-center space-x-1 bg-primary/10 text-primary px-3 py-1 rounded-full text-sm">
              <span>
                {serviceTypeOptions.find(opt => opt.value === filters.serviceType)?.label[currentLanguage]}
              </span>
              <button
                onClick={() => handleFilterChange('serviceType', 'all')}
                className="hover:text-primary/80"
              >
                <Icon name="X" size={14} />
              </button>
            </span>
          )}
          {filters.poolSize !== 'all' && (
            <span className="inline-flex items-center space-x-1 bg-primary/10 text-primary px-3 py-1 rounded-full text-sm">
              <span>
                {poolSizeOptions.find(opt => opt.value === filters.poolSize)?.label[currentLanguage]}
              </span>
              <button
                onClick={() => handleFilterChange('poolSize', 'all')}
                className="hover:text-primary/80"
              >
                <Icon name="X" size={14} />
              </button>
            </span>
          )}
          {filters.location !== 'all' && (
            <span className="inline-flex items-center space-x-1 bg-primary/10 text-primary px-3 py-1 rounded-full text-sm">
              <span>{filters.location}</span>
              <button
                onClick={() => handleFilterChange('location', 'all')}
                className="hover:text-primary/80"
              >
                <Icon name="X" size={14} />
              </button>
            </span>
          )}
        </div>
      )}
    </div>
  );
};

export default FilterControls;